import { useState, useCallback, useRef, useEffect } from 'react'
import { TextField, InputAdornment, IconButton } from '@mui/material'
import { Search, Clear } from '@mui/icons-material'

export default function SearchBar({ gridRef }) {
  const [value, setValue] = useState('')
  const debounceRef = useRef(null)

  const applyFilter = useCallback(
    (text) => {
      if (gridRef?.current?.api) {
        gridRef.current.api.setGridOption('quickFilterText', text || '')
      }
    },
    [gridRef],
  )

  useEffect(() => {
    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current)
    }
  }, [])

  const handleChange = (e) => {
    const text = e.target.value
    setValue(text)
    if (debounceRef.current) clearTimeout(debounceRef.current)
    debounceRef.current = setTimeout(() => applyFilter(text), 150)
  }

  const handleClear = () => {
    setValue('')
    applyFilter('')
  }

  return (
    <TextField
      value={value}
      onChange={handleChange}
      placeholder="Search item #, description, brite code…"
      size="small"
      sx={{
        width: 300,
        '& .MuiInputBase-input': { fontSize: '0.8125rem', py: 0.75 },
      }}
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <Search sx={{ fontSize: 18, color: 'text.secondary' }} />
            </InputAdornment>
          ),
          endAdornment: value ? (
            <InputAdornment position="end">
              <IconButton size="small" onClick={handleClear} edge="end">
                <Clear sx={{ fontSize: 16 }} />
              </IconButton>
            </InputAdornment>
          ) : null,
        },
      }}
    />
  )
}
